import { useCallback } from "react";
import { useHistory, useLocation } from "react-router";

import { enterEditMode, exitEditMode, isInEditMode } from "utilities/editMode/edit.utility";

// TODO: rework this when we have a functional component example for view / edit mode
export function useEditMode() {
    const history = useHistory();
    const location = useLocation();

    const localEnterEditMode = useCallback(() => {
        enterEditMode(location, history);
    }, [history, location]);

    const localExitEditMode = useCallback(() => {
        exitEditMode(history);
    }, [history]);

    return {
        isInEditMode: isInEditMode(location),
        enterEditMode: localEnterEditMode,
        exitEditMode: localExitEditMode,
    };
}
